import React, { useState }  from 'react';

import { PostRequest } from 'components/common/index.js';

const UpdatePaymentMethod = () => {

  const [disabled, setDisabled] = useState('');
  const [cta, setCta] = useState(t('sign_up.update_my_card'));
  const stripe = Stripe(window.stripePublishableKey);

  const handleClick = (e) => {
    e.preventDefault();
    setDisabled( () => 'disabled' );
    setCta( () => t('sign_up.please_wait'))

    PostRequest({
      url: '/charges/create_checkout_session',
      callback: ( data ) => {
        setDisabled( () => '' );
        stripe.redirectToCheckout({
          sessionId: data.session_id
        })

      }
    })
  }

  return (
    <a className="btn subscription-card-action-primary" onClick={handleClick} disabled={disabled} href="#"> {cta} </a>
  )
}

export default UpdatePaymentMethod;
